import { gql } from "@apollo/client";

import { groupDetailsFragment } from "../fragments";

export const getGroupName = gql`
    query getGroupName($id: String!, $organizationId: String = null) {
        getGroupV2(input: { id: $id, lensLimit: 0, organizationId: $organizationId }) {
            group {
                name
                id
            }
        }
    }
`;

// lensLimit should be consistent with backend (currently set to a max of 500):
// eslint-disable-next-line max-len
// https://github.sc-corp.net/Snapchat/camera-kit-admin-backend/blob/f027d25b4453b87ba089bd0f9d40c838a8ccb261/pkg/cmd/service/connections.go#L17-L20
export const getGroupDetails = gql`
    query getGroupDetails($id: String!, $organizationId: String = null) {
        getGroupV2(input: { id: $id, lensLimit: 500, organizationId: $organizationId }) {
            ...GroupDetails
        }
    }
    ${groupDetailsFragment}
`;
